import useIHeartTracking from '~/components/useIHeartTracking';

export default useIHeartTracking;
